/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * HackStalker.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { fetchApi } from "../../../fetch";
import type {
  AddUserInteractionClickIssueParams,
  AddUserInteractionScanRepositoryParams,
  AddUserInteractionViewAnalysisParams,
  AddUserInteractionViewPageParams,
  UserInteractionDtoOfClickIssueDataDto,
  UserInteractionDtoOfScanRepositoryDataDto,
  UserInteractionDtoOfViewAnalysisDataDto,
  UserInteractionDtoOfViewPageDataDto,
} from "../../models";

export const getAddUserInteractionViewPageUrl = (params?: AddUserInteractionViewPageParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `/interactions/interaction/view-page?${normalizedParams.toString()}`
    : `/interactions/interaction/view-page`;
};

export const addUserInteractionViewPage = async (
  userInteractionDtoOfViewPageDataDto: UserInteractionDtoOfViewPageDataDto,
  params?: AddUserInteractionViewPageParams,
  options?: RequestInit,
): Promise<void> => {
  return fetchApi<void>(getAddUserInteractionViewPageUrl(params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(userInteractionDtoOfViewPageDataDto),
  });
};

export const getAddUserInteractionViewAnalysisUrl = (
  params?: AddUserInteractionViewAnalysisParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `/interactions/interaction/view-analysis?${normalizedParams.toString()}`
    : `/interactions/interaction/view-analysis`;
};

export const addUserInteractionViewAnalysis = async (
  userInteractionDtoOfViewAnalysisDataDto: UserInteractionDtoOfViewAnalysisDataDto,
  params?: AddUserInteractionViewAnalysisParams,
  options?: RequestInit,
): Promise<void> => {
  return fetchApi<void>(getAddUserInteractionViewAnalysisUrl(params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(userInteractionDtoOfViewAnalysisDataDto),
  });
};

export const getAddUserInteractionScanRepositoryUrl = (
  params?: AddUserInteractionScanRepositoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `/interactions/interaction/scan-repository?${normalizedParams.toString()}`
    : `/interactions/interaction/scan-repository`;
};

export const addUserInteractionScanRepository = async (
  userInteractionDtoOfScanRepositoryDataDto: UserInteractionDtoOfScanRepositoryDataDto,
  params?: AddUserInteractionScanRepositoryParams,
  options?: RequestInit,
): Promise<void> => {
  return fetchApi<void>(getAddUserInteractionScanRepositoryUrl(params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(userInteractionDtoOfScanRepositoryDataDto),
  });
};

export const getAddUserInteractionClickIssueUrl = (params?: AddUserInteractionClickIssueParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `/interactions/interaction/click-issue?${normalizedParams.toString()}`
    : `/interactions/interaction/click-issue`;
};

export const addUserInteractionClickIssue = async (
  userInteractionDtoOfClickIssueDataDto: UserInteractionDtoOfClickIssueDataDto,
  params?: AddUserInteractionClickIssueParams,
  options?: RequestInit,
): Promise<void> => {
  return fetchApi<void>(getAddUserInteractionClickIssueUrl(params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(userInteractionDtoOfClickIssueDataDto),
  });
};
